/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



















document.addEventListener('DOMContentLoaded', function() {
fetch('/browsing_context_suggestions.json')
  .then(response => response.json())
  .then(data => {
    const countryCode = data?.detected_values?.country?.handle; // Extract the country code
    //console.log("you are coming from: ", countryCode);
    if (countryCode === 'GB') {

    $(".template-product .product__block.product__icon__row").show();
    } else {
      // User is not from UK
    /*$("div#shopify-section-template--18268731375872__slideshow").hide();*/
    

    }

  })
  .catch(error => {
    console.error('Error:', error);
    // Handle error if the request fails
  });
  
});





document.addEventListener('DOMContentLoaded', function() {
  fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const countryCode = data?.detected_values?.country?.handle; // Extract the country code

      if (countryCode === 'AE') {
        if (window.location.href === "https://equilondon.com/" || window.location.href === "https://equilondon.com") {
          console.log("Redirecting to .me domain");
          // Perform a redirect to 'https://www.equilondon.me'
          window.location.href = "https://www.equilondon.me";
        }
      }

      if (countryCode === 'GB' || countryCode === 'UK') {
        $('.template-product .product__block.product__icon__row').fadeIn();
      } else {
        // Hide the subscription widget for customers outside the UK
        document.querySelectorAll('.rc-radio.subscription-radio.px-3.py-2').forEach(el => {
          el.style.display = 'none';
        });
      }
    })
    .catch(error => {
      console.error('Error:', error);
      // Handle error if the request fails
    });
});

/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


$(document).ready(function() {
  setTimeout(function () {
    $('.template-product .recharge-subscription-widget .money').wrap('<span class="transcy-money"></span>');
  }, 1000);
  // Event listener for the click on the first element
  $('div#shopify-section-template--16808021197056__9f6bfc27-899e-4202-baa1-44bb00b3d274 .image-overlay').click(function() {
    // Create the popup dynamically
    var popupOverlay = $('<div class="popup-overlay"></div>');
    var popupContent = $('<div class="popup-content"><img src="https://equilondon.com/cdn/shop/files/EQUI_Find_Your_Formula_-_EneryFocus_59825341-4d5d-48e2-bec7-ba7e7e133dd3_1950x.png?v=1690902704" alt="Popup Image"></div>');

    // Append the popup elements to the body
    $('body').append(popupOverlay);
    $('body').append(popupContent);

    // Show the popup
    $('.popup-overlay').fadeIn();
    $('body').addClass('popup-open');
  });

  // Event listener for the click on the second element
  $('div#shopify-section-template--16808021197056__3d33cdb8-5829-4fdf-8784-2ac95d2dde31 .image-overlay').click(function() {
    // Create the popup dynamically
    var popupOverlay = $('<div class="popup-overlay"></div>');
    var popupContent = $('<div class="popup-content"><img src="https://equilondon.com/cdn/shop/files/EQUI_Find_Your_Formula_-_EneryFocus_1_d8d9b022-a77f-4201-88c2-3c11df8c562e_1950x.png?v=1690903125" alt="Popup Image"></div>');

    // Append the popup elements to the body
    $('body').append(popupOverlay);
    $('body').append(popupContent);

    // Show the popup
    $('.popup-overlay').fadeIn();
    $('body').addClass('popup-open');
  });

    // Event listener for the click on the third element
  $('div#shopify-section-template--16808021197056__31d8cb29-25ff-4c01-859d-5b6ca068343d .image-overlay').click(function() {
    // Create the popup dynamically
    var popupOverlay = $('<div class="popup-overlay"></div>');
    var popupContent = $('<div class="popup-content"><img src="https://equilondon.com/cdn/shop/files/EQUI_Find_Your_Formula_-_EneryFocus_3_1950x.png?v=1690906910" alt="Popup Image"></div>');

    // Append the popup elements to the body
    $('body').append(popupOverlay);
    $('body').append(popupContent);

    // Show the popup
    $('.popup-overlay').fadeIn();
    $('body').addClass('popup-open');
  });

  
  // Event listener for clicking outside of the popup
  $(document).on('click', '.popup-overlay', function(event) {
    if (event.target === this) {
      // Close the popup when clicking outside of it
      $('.popup-overlay').fadeOut();
      $('.popup-content').remove(); // Remove the dynamically added popup content
      $('body').removeClass('popup-open');
    }
  });
});


$(document).ready(function() {
  // Select the element after which you want to append the HTML
  const targetElement = $("#shopify-section-template--16804879237376__37b0e1c7-3f2c-4d30-b4c2-794c06d2e383 .hero__content.hero__content--compact.text-left");

  // Create the HTML to be appended
  const htmlToAppend = '<img src="https://cdn.shopify.com/s/files/1/0961/3808/files/icons_with_sticker.png?v=1693939573" class="custom-icons-img">';

  // Append the HTML after the target element
  targetElement.after(htmlToAppend);

    var intrvl = setInterval(function(){
    if($('.rc-radio__price').length) {
      $('.rc-radio__price').addClass('spacebtw money');
      //$('.rc-radio__price').addClass('notranslate transcy-money');
      $('.onetime-radio .rc-radio__label').each(function(){
        var $ol = $(this),
          p = $ol.html().replaceAll("One-time Purchase", '');
        console.log(p, '<<<<<<<<<<<<');
        $ol.html(`<span>One-time Purchase </span> <span class="cus_ol_p money">${p}</span>`)
        typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined" && mlvedaload()
      });
      clearInterval(intrvl);
    }
  });
  setTimeout(function(){clearInterval(intrvl);}, 20000);
});


$(document).ready(function() {
    // Loop through each element with class .product__icon__container.product__icon__container--full
    $('.product__icon__container.product__icon__container--full').each(function() {
        // Check if the current element has a .product__icon__text child
        if (!$(this).find('.product__icon__text').length) {
            // Apply display: none if it doesn't have a .product__icon__text child
            $(this).css('display', 'none');
        }
    });
});


function updateContent() {
    $("span.rc-selling-plans-single").html('<div class="subtext"><span>Never run out</span><span>Cancel anytime</span><span>Guaranteed delivery during sell-outs</span></div>');
}

// Function to update the content
function updateContent() {
    var targetElement = document.querySelector("span.rc-selling-plans-single");
    if (targetElement) {
        targetElement.innerHTML = '<div class="subtext"><span>Never run out</span><span>Cancel anytime</span><span>Guaranteed delivery during sell-outs</span></div>';
    }
}

// Function to set up the MutationObserver
function setupObserver() {
    var targetElement = document.querySelector("span.rc-selling-plans-single");

    if (targetElement) {
        // Create a new observer with a callback function
        var observer = new MutationObserver(function (mutationsList, observer) {
            // When a mutation occurs, update the content
            updateContent();
        });

        // Start observing the target element for changes to its subtree
        observer.observe(targetElement, { subtree: true, childList: true });
    }
}

// Start observing for changes
setupObserver();



/*
$(document).ready(function() {
    var $entry = $(".product__description__content__entry").eq(0);
    var fullText = $entry.html();
    
    var characterLimit = parseInt($(".product__block.product__description.rte").data("character-limit"));
    var truncationLength = (characterLimit === 0) ? Math.ceil(fullText.length / 2.2) : characterLimit;
    
    var truncatedText = fullText.slice(0, truncationLength);

    if (fullText.length > truncationLength) {
        $entry.empty().addClass("truncate").html('<div>' + truncatedText + '</div>')
            .append('<span class="read-more-link">... <a href="#">Read More</a></span>')
            .data("full-text", fullText);
    }

    $(".read-more-link a").on("click", function(e) {
        e.preventDefault();
        $entry.html($entry.data("full-text")).removeClass("truncate");
        $(this).parent().remove();
    });
});
*/


$(document).ready(function() {
  
    var $sellingPlans;
    var $radioButton;
    var $subtext;

    // Periodically check for the existence of elements
    var checkForElements = setInterval(function() {
      $sellingPlans = $(".rc-selling-plans-single");
      $radioButton = $(".rc-radio");
      $subtext = $(".rc-radio__subscription");
         const newContent = `
        <span class="rc-selling-plans-single" data-v-ac513cdf="">Delivery every 30 Days</span>
        <span class="rc-selling-plans-single" data-v-ac513cdf="">Guaranteed delivery if we sell out</span>
        <span class="rc-selling-plans-single" data-v-ac513cdf="">Save 15% every month</span>
        <span class="rc-selling-plans-single" data-v-ac513cdf="">Pause or cancel at anytime</span>
    `;
      
      
      if ($radioButton.length > 0) {
        // Elements found, clear the interval and proceed
        clearInterval(checkForElements);
        $('.rc-template__radio .rc-selling-plans').html(newContent);
        // Function to update the content
        var updateContent = function() {
          $sellingPlans = $(".rc-selling-plans-single");
          $subtext = $(".rc-radio__subscription");
          
          /*$sellingPlans.html("- Delivery every 30 days<br>- Save 15% every month<br>- Modify or cancel anytime");*/
          $subtext.html('Subscribe <span class="yellow">Save 15%</span>');
          
          console.log("btn clicked");

      

    $('.rc-radio').on('click', function () {
      console.log("subscribe clicked");
      setTimeout(function () {
            $('.rc-template__radio .rc-selling-plans').html(newContent);
           }, 50); // Delay of 50ms
    });
          
        };

        // Initial content update
        updateContent();

        // Bind the updateContent function to the click event of .rc-radio with a delay
        $radioButton.on("click", function() {
          // Clear any previous timeouts to avoid multiple executions
          clearTimeout($radioButton.data("timeoutId"));

          // Set a new timeout with a delay
          var timeoutId = setTimeout(updateContent, 100);

          // Store the timeoutId in data to be able to clear it later
          $radioButton.data("timeoutId", timeoutId);
        });
      }
    }, 100); // Check every 100ms
  });


 $(document).ready(function() {
      // Create the new <p> element
      var newParagraph = $('<p class="poptions">Purchase Options</p>');

      // Insert it before the element with class "recharge-subscription-widget"
      $('.recharge-subscription-widget').before(newParagraph);
    });





  $(document).ready(function() {
      // Initial setup
      $(".the_switcher.lefts").addClass("activeside");
      $(".capsulespow").show();
      $(".powderpow").hide();

      // Click event for ".the_switcher.lefts"
      $(".the_switcher.lefts").click(function() {
        $(this).addClass("activeside");
        $(".the_switcher.rights").removeClass("activeside");
        $(".capsulespow").fadeIn();
        $(".powderpow").hide();
      });

      // Click event for ".the_switcher.rights"
      $(".the_switcher.rights").click(function() {
        $(this).addClass("activeside");
        $(".the_switcher.lefts").removeClass("activeside");
        $(".powderpow").fadeIn();
        $(".capsulespow").hide();
      });
    });









$(document).ready(function() {
    // Check if the current URL contains '/de' (either '/de/' or just '/de')
    if (window.location.href.indexOf('/de') !== -1) {
        // Combine selectors and update href attributes
        $('.variant_boxes a, .mega_content a').each(function() {
            // Get the current href attribute
            var currentHref = $(this).attr('href');
            
            // Add '/de/' to the URL if it's not already there
            if (currentHref && currentHref.indexOf('/de/') === -1) {
                var newHref;
                
                // Check if the current href is an absolute URL
                if (currentHref.startsWith('https://equilondon.com')) {
                    // Extract the base URL and path
                    var baseUrl = 'https://equilondon.com/de';
                    var path = currentHref.replace('https://equilondon.com', '');
                    
                    // Construct the new href
                    newHref = baseUrl + path;
                } else if (currentHref.startsWith('/')) {
                    // For relative URLs, just prepend '/de'
                    newHref = '/de' + currentHref;
                }
                
                // Set the new href attribute
                $(this).attr('href', newHref);
            }
        });
    }
});









/*
document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelector('.cart__checkout').addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = '/checkout';
    });
});*/


/*
$(document).ready(function() {
  $('.shopnow-btn').on('click', function(e) {
    e.preventDefault(); // Prevent the default behavior of the .shopnowbtn click

    // Find the closest .quick-add__button to the clicked .shopnowbtn and trigger a click
    $(this).closest('.product-item').find('.quick-add__button').click();
  });
});
*/







$(document).ready(function() {
    $('em').each(function() {
        if ($(this).text() === '{reviews}') {
            $(this).replaceWith('<p class="reviews_content"><img src="https://cdn.shopify.com/s/files/1/0961/3808/files/Component_1.svg?v=1733767545"><span>Loved by 60,000+</span></p>');
        }
    });
});

  



  $(document).ready(function () {
    if (window.innerWidth <= 768) { // Mobile-only condition
        $('section.section-padding.has_icons.custom_layout').each(function () {
            const $parentSection = $(this);

            // Move h2.hero__title above .brick__block__image.frame.wide-image
            const $heroTitle = $parentSection.find('h2.hero__title');
            const $wideImage = $parentSection.find('.brick__block__image.frame.wide-image');
            if ($heroTitle.length && $wideImage.length) {
                $wideImage.before($heroTitle);
            }

            // Add new <p> element after h2.hero__title
            const newParagraph = $('<p><strong>GlowCutis® isn’t just skincare—it’s skin transformation.</strong></p>');
            $heroTitle.after(newParagraph);

            // Remove <strong> element containing specified text
            $parentSection.find('.hero__rte strong:contains("GlowCutis® isn’t just skincare—it’s skin transformation")').each(function () {
                $(this).remove();
            });

            // Move .hero__content.hero__content--transparent after .hero__rte
            const $heroContent = $parentSection.find('.hero__content.hero__content--transparent');
            const $heroRte = $parentSection.find('.hero__rte');
            if ($heroContent.length && $heroRte.length) {
                $heroRte.after($heroContent);
            }
        });
    }
});
  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





(function() {
    if (window.innerWidth <= 768) { // Mobile devices only
        const baseUrl = "https://equilondon.com/pages/which-product-is-right-for-me";
        const targetUrl = `${baseUrl}#quiz-kit-key-ThGt62Y62`;
        const homeUrl = "https://equilondon.com/";

        // Ensure full redirection by checking if the hash exists
        if (window.location.href === baseUrl) {
            setTimeout(() => {
                if (!window.location.hash.includes("quiz-kit-key-ThGt62Y62")) {
                    window.location.assign(targetUrl); // Forces full navigation
                    window.location.reload(true); // Ensures full reload
                }
            }, 100);
        }

        // Function to handle close button click
        const handleButtonClick = () => {
            window.location.assign(homeUrl); // Forces full navigation to home
        };

        // Set up MutationObserver for the close button
        const observeCloseButton = () => {
            const closeButton = document.querySelector('.quizkit-popup__close');
            if (closeButton) {
                closeButton.addEventListener('click', handleButtonClick);
            }
        };

        // Initialize MutationObserver
        const observer = new MutationObserver(observeCloseButton);
        observer.observe(document.body, { childList: true, subtree: true });

        // Initial check in case the button is already present
        observeCloseButton();
    }
})();




